export const GET_LIST_START = "@operators/GET_LIST_START";
export const GET_LIST_SUCCESS = "@operators/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@operators/GET_LIST_FAIL";
export const GET_DETAIL_START = "@operators/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@operators/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@operators/GET_DETAIL_FAIL";
export const GET_OPERATOR_CASINOS_START = "@operators/GET_OPERATOR_CASINOS_START";
export const GET_OPERATOR_CASINOS_SUCCESS = "@operators/GET_OPERATOR_CASINOS_SUCCESS";
export const GET_OPERATOR_CASINOS_FAIL = "@operators/GET_OPERATOR_CASINOS_FAIL";
export const GET_OPERATOR_SETUPS_START = "@operators/GET_OPERATOR_SETUPS_START";
export const GET_OPERATOR_SETUPS_SUCCESS = "@operators/GET_OPERATOR_SETUPS_SUCCESS";
export const GET_OPERATOR_SETUPS_FAIL = "@operators/GET_OPERATOR_SETUPS_FAIL";
export const GET_CREDENTIALS_START = "@operators/GET_CREDENTIALS_START";
export const GET_CREDENTIALS_SUCCESS = "@operators/GET_CREDENTIALS_SUCCESS";
export const GET_CREDENTIALS_FAIL = "@operators/GET_CREDENTIALS_FAIL";
export const GET_USERS_START = "@operators/GET_USERS_START";
export const GET_USERS_SUCCESS = "@operators/GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "@operators/GET_USERS_FAIL";
